export default {"src":"/_next/static/media/tick.82fe73d6.svg","height":15,"width":15};